import Component from "./idd.component";
import { Config } from "./idd.config";
import { watchIdd as saga } from "./redux/idd.sagas";
import { reducer } from "./redux/idd.reducer";

export default { Component, saga, reducer, config: Config };
